import React from 'react';
import { Box, Badge } from '@cloudscape-design/components';
import AddressChip from './AddressChip';
import EdgeToggle from './EdgeToggle';

/**
 * Compact single-row header: agent wallet + balance + session spend (vs budget) +
 * the Monetized/Blocked seller-WAF toggle — all on one line.
 */
export default function BuyerWallet({ wallet, spentUsdc, budgetUsdc, edge, onEdgeChange, edgeDisabled }) {
  const spent = Number(spentUsdc || 0);
  const budget = Number(budgetUsdc || 0.1);
  const pct = budget > 0 ? Math.min(100, Math.round((spent / budget) * 100)) : 0;

  const cell = { display: 'flex', flexDirection: 'column', gap: 2 };

  return (
    <div
      style={{
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        gap: 24,
        rowGap: 8,
      }}
    >
      <div style={cell}>
        <Box variant="awsui-key-label">Agent wallet</Box>
        <AddressChip address={wallet?.address} showFaucet />
      </div>

      <div style={cell}>
        <Box variant="awsui-key-label">Balance</Box>
        <Box fontSize="body-s">
          {wallet?.usdc != null ? `${wallet.usdc.toFixed(3)} USDC` : '—'}
        </Box>
      </div>

      <div style={cell}>
        <Box variant="awsui-key-label">Spent this session</Box>
        <Badge color={pct >= 100 ? 'red' : pct >= 80 ? 'grey' : 'green'}>
          {spent.toFixed(3)} / {budget.toFixed(2)} USDC ({pct}%)
        </Badge>
      </div>

      <div style={{ ...cell, marginLeft: 'auto' }}>
        <Box variant="awsui-key-label">Seller WAF treats agents as</Box>
        <EdgeToggle value={edge} onChange={onEdgeChange} disabled={edgeDisabled} compact />
      </div>
    </div>
  );
}
